export const SET_USERS = "USERS_SET_USERS";
export const PUSH_USERS = "USERS_PUSH_USERS";
export const PATCH_USER = "USERS_PATCH_USER";
export const SET_LASTID = "USERS_SET_LASTID";
export const SET_ACCOUNTTYPE = "USERS_SET_ACCOUNTTYPE";
export const SET_ERROR = "USERS_SET_ERROR";
export const SET_FETCHING = "USERS_SET_FETCHING";
export const SET_SEARCH = "USERS_SET_SEARCH";
